// extracted by mini-css-extract-plugin
export default {"wrapper":"Cabinet_wrapper__APH-9"};